import { Switch } from 'react-router';
import PrivateRoute from '@/routes/PrivateRoute';
import UserProfilePage from '@/components/pages/user/UserProfilePage';
import UserPasswordPage from '@/components/pages/user/UserPasswordPage';

const UserRoute = () => {
  return (
    <Switch>
      <PrivateRoute path="/user/profile" exact component={UserProfilePage} />
      <PrivateRoute path="/user/password" exact component={UserPasswordPage} />
    </Switch>
  );
};

export default UserRoute;
